<template>
  <div>
    <section-title content="Ia. Información del Estudiante" :has-line="true" />
    <div class="row my-3" v-if="canShowValidationDate">
      <div class="d-flex col-lg-3 col-md-3 col-12 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Fecha de Validación:
        </label>
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            required
            v-model="studentInfoValue.validationDate"
            placeholder="DD/MM/YYYY"
            :container-class="'w-100'"
            :error="errors[0]"
            :max-date="new Date()"
            :disabled="isReadOnly"
            @input="modelChanged()"
            :custom-error-msg="'La Fecha de Validación es requerida'"
          />
        </validation-provider>
      </div>
    </div>
    <div class="row mb-4">
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Numero de SIE:
        </label>
        <span>{{ studentInfoValue?.sieId }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Número de Registro:
        </label>
        <span>{{ studentInfoValue?.registryNumber }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Nombre del Estudiante:
        </label>
        <span>{{ studentInfoValue?.studentName }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Fecha de Nacimiento:
        </label>
        <span>{{ studentInfoValue?.birthdate | formatDate }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Edad Cronológica:
        </label>
        <span>{{ studentInfoValue?.cronoAge }}</span>
      </div>

      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Impedimento:
        </label>
        <span>{{ studentInfoValue?.impediment }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Distrito:
        </label>
        <span>{{ studentInfoValue?.district }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Municipio:
        </label>
        <span>{{ studentInfoValue?.municipality }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Escuela:
        </label>
        <span>{{ studentInfoValue?.school }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Telefono Escuela:
        </label>
        <span>{{ studentInfoValue?.schoolPhone | formatPhoneNumber }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Ubicación Escolar:
        </label>
        <span>{{ studentInfoValue?.schoolLocation }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Nombre Padre, Madre o Tutor:
        </label>
        <span>{{ studentInfoValue?.personInCharge }}</span>
      </div>
      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Teléfono:
        </label>
        <span>
          {{ studentInfoValue?.telephoneNumber | formatPhoneNumber }}
        </span>
      </div>

      <div class="d-flex col-lg-2 col-md-6 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal ">
          Maestro Educación Especial:
        </label>
        <span v-if="isReadOnly">
          {{ studentInfoValue?.specialEducationTeacher }}
        </span>
        <div
          class="color-black font-16 mt-2 font-weight-bold"
          v-if="!isReadOnly"
        >
          <validation-provider
            mode="eager"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <custom-input
              :disabled="isReadOnly"
              placeholder="Maestro Educación Especial"
              type="text"
              @input="modelChanged()"
              v-model="studentInfoValue.specialEducationTeacher"
              :error="errors[0]"
              :custom-error-msg="'El Maestro Educación Especial es requerido'"
            />
          </validation-provider>
        </div>
      </div>
      <div class="d-flex col-lg-5 col-md-9 col-sm-12 my-3 flex-column">
        <label class="color-secondary-6 font-14 font-weight-normal">
          Dirección Residencial:
        </label>
        <span v-if="isReadOnly">{{ studentInfoValue?.address }}</span>
        <div
          class="color-black font-16 mt-2 font-weight-bold"
          v-if="!isReadOnly"
        >
          <validation-provider
            mode="eager"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <custom-input
              :disabled="isReadOnly"
              placeholder="Dirección Residencial"
              type="text"
              @input="modelChanged()"
              v-model="studentInfoValue.address"
              :error="errors[0]"
              :custom-error-msg="'La Dirección Residencial es requerida'"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomInput from 'CustomInput';
import moment from 'moment';
import CustomDatePicker from 'custom-date-picker';
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    SectionTitle,
    CustomInput,
    CustomDatePicker,
    ValidationProvider,
  },
  filters: {
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    formatPhoneNumber(value) {
      if (!value) return '';
      // Assuming the phone number format is 1234567890, adjust as needed
      return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
    },
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
    studentInfo: {
      type: Object,
      default: () => ({}),
    },
    isAppraisal: {
      type: Boolean,
      default: () => false,
    },
    isValidation: {
      type: Boolean,
      default: () => false,
    },
    isEquipmentRelatedServiceRequest: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      studentInfoValue: {
        address: null,
        specialEducationTeacher: null,
        validationDate: null,
      },
    };
  },
  computed: {
    canShowValidationDate() {
      return (
        this.isAppraisal ||
        this.isValidation ||
        this.isEquipmentRelatedServiceRequest
      );
    },
  },
  watch: {
    studentInfo: {
      immediate: true,
      handler(value, oldValue) {
        if (value != null && value != undefined) {
          this.studentInfoValue = value;
          this.modelChanged();
        }
      },
    },
  },
  methods: {
    modelChanged() {
      this.$emit('input', {
        specialEducationTeacher: this.studentInfoValue.specialEducationTeacher,
        address: this.studentInfoValue.address,
        validationDate: this.studentInfoValue.validationDate,
      });
    },
  },
};
</script>

<style scoped></style>
